import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProductPreview from './ProductPreview';

export default function Hero() {
  const navigate = useNavigate();

  const scrollToFeatures = (e) => {
    e.preventDefault();
    const element = document.querySelector('#features');
    if (element) {
      const topOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - topOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
      {/* Background Gradients & Glow Effects */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-600/15 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute top-1/3 right-10 w-[400px] h-[400px] bg-purple-600/10 rounded-full blur-[100px] pointer-events-none" />
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:48px_48px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {/* Eyebrow Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 backdrop-blur-md mb-8 text-xs font-bold tracking-widest text-blue-400 uppercase shadow-inner">
          <span className="w-2 h-2 rounded-full bg-blue-500 animate-ping" />
          MODERN SCHOOL MANAGEMENT
        </div>

        {/* Hero Title */}
        <h1 className="font-serif text-4xl sm:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-[1.1] mb-6 max-w-4xl mx-auto">
          Everything Your School Needs.{' '}
          <span className="bg-gradient-to-r from-blue-400 via-indigo-300 to-purple-400 bg-clip-text text-transparent block sm:inline">
            In One Powerful Platform.
          </span>
        </h1>

        {/* Hero Subtitle */}
        <p className="text-slate-300 text-base sm:text-lg md:text-xl max-w-3xl mx-auto leading-relaxed mb-10 font-normal">
          EduPortal brings administrators, teachers, students, and parents together in one simple platform for managing academics, attendance, assignments, communication, and performance.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <button
            onClick={() => navigate('/select-role')}
            className="w-full sm:w-auto text-base font-bold text-white bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 hover:from-blue-500 hover:via-indigo-500 hover:to-purple-500 px-8 py-4 rounded-xl shadow-xl shadow-blue-600/30 hover:shadow-blue-600/50 transition-all duration-300 hover:-translate-y-1 flex items-center justify-center gap-2 group"
          >
            <span>Get Started</span>
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </button>
          <a
            href="#features"
            onClick={scrollToFeatures}
            className="w-full sm:w-auto text-base font-semibold text-slate-200 hover:text-white bg-white/5 hover:bg-white/10 border border-white/10 px-8 py-4 rounded-xl backdrop-blur-md transition-all duration-300 hover:-translate-y-1 text-center"
          >
            Explore the Platform
          </a>
        </div>

        {/* Supporting Indicators */}
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-xs sm:text-sm text-slate-400 font-medium">
          <div className="flex items-center gap-2 bg-white/5 border border-white/10 px-3.5 py-1.5 rounded-full">
            <span className="text-emerald-400">✓</span> Built for Schools
          </div>
          <div className="flex items-center gap-2 bg-white/5 border border-white/10 px-3.5 py-1.5 rounded-full">
            <span className="text-blue-400">✓</span> 4 Role-Based Experiences
          </div>
          <div className="flex items-center gap-2 bg-white/5 border border-white/10 px-3.5 py-1.5 rounded-full">
            <span className="text-purple-400">✓</span> Centralized Academic Management
          </div>
        </div>

        {/* Hero Interactive Product Visual */}
        <ProductPreview />
      </div>
    </section>
  );
}
